<template>
  <!-- eslint-disable max-len -->
  <el-dialog
    title="产品详情"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="70%"
    top="5%"
    class="ds-detail"
    append-to-body
    :close-on-click-modal="false"
  >
    <el-tabs
      type="border-card"
      ref="tabs"
      v-model="activeTab"
      style="margin-top: -30px"
    >
      <el-tab-pane label="维修记录" name="tabRegister">
        <el-row :gutter="20">
          <el-col :span="16">
            <el-form :model="item" label-width="150px">
              <div class="border-style">登记信息</div>

              <table
                border="1"
                bordercolor="#dedede"
                style="
                  width: 100%;
                  border-collapse: collapse;
                  font-size: 13px;
                  margin-bottom: 15px;
                "
              >
                <tr height="40">
                  <th width="15%">维修类型</th>
                  <td width="35%">
                    <div v-if="item.Type === 0">产品</div>
                    <div v-else>配件</div>
                  </td>
                  <th width="15%">登记人</th>
                  <td width="35%">
                    <div v-if="item.SendPeople">
                      {{ item.SendPeople.Name }}
                    </div>
                  </td>
                </tr>
                <tr height="40">
                  <th>
                    <div v-if="item.Type === 0">产品型号名称</div>
                    <div v-else>配件型号名称</div>
                  </th>
                  <td>
                    <div v-if="item.Type === 0">
                      <div v-if="item.DciProduct">
                        <div v-if="item.DciProduct.DciProductModel">
                          {{ item.DciProduct.DciProductModel.NameNumber }}
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <div v-if="item.DciAccessory">
                        <div v-if="item.DciAccessory.DciAccessoryModel">
                          {{ item.DciAccessory.DciAccessoryModel.NameNumber }}
                        </div>
                      </div>
                    </div>
                  </td>
                  <th>
                    <div v-if="item.Type === 0">产品SN</div>
                    <div v-else>配件SN</div>
                  </th>
                  <td>
                    <div v-if="item.Type === 0">
                      <div v-if="item.DciProduct">
                        {{ item.DciProduct.SN }}
                      </div>
                      <div v-if="item.DciProduct && item.DciProduct.Remark">
                        {{ item.DciProduct.Remark }}
                      </div>
                    </div>
                    <div v-else>
                      <div v-if="item.DciAccessory">
                        {{ item.DciAccessory.SN }}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr height="40">
                  <th>送修日期</th>
                  <td>
                    <div v-if="item.SendAt">
                      {{ $sys.dateFormat(item.SendAt, "Y-m-d") }}
                    </div>
                  </td>
                  <th>临期提醒天数</th>
                  <td>{{ item.TenseDays }}</td>
                </tr>
                <tr height="40">
                  <th>送修来源</th>
                  <td colspan="3">
                    {{ item.SendSource }}
                  </td>
                </tr>
                <tr height="40">
                  <th>期望初检<br />完成日期</th>
                  <td>
                    <div v-if="item.ExpectedInspectAt">
                      {{
                        $sys.dateFormat(item.ExpectedInspectAt, "Y-m-d H:i:s")
                      }}
                    </div>
                  </td>
                  <th>期望维修<br />完成日期</th>
                  <td>
                    <div v-if="item.ExpectedDealAt">
                      {{ $sys.dateFormat(item.ExpectedDealAt, "Y-m-d H:i:s") }}
                    </div>
                  </td>
                </tr>

                <tr height="40">
                  <th>故障说明</th>
                  <td colspan="3">{{ item.MalfunctionDesc }}</td>
                </tr>
                <tr height="40">
                  <th>办结说明</th>
                  <td colspan="3">{{ item.FinishDesc }}</td>
                </tr>
                <tr height="40">
                  <th>快递单号</th>
                  <td>{{ item.ExpressNumber }}</td>
                  <th>寄出日期</th>
                  <td>
                    <div v-if="item.SendingAt">
                      {{ $sys.dateFormat(item.SendingAt, "Y-m-d") }}
                    </div>
                  </td>
                </tr>
                <tr height="40">
                  <th>收件人</th>
                  <td>{{ item.Addressee }}</td>
                  <th>快递说明</th>
                  <td>{{ item.ExpressDesc }}</td>
                </tr>
              </table>

              <div
                style="
                  text-align: right;
                  padding-bottom: 10px;
                  margin-top: -10px;
                "
              >
                <el-button
                  type="primary"
                  size="mini"
                  @click="onUpdateFinishClick"
                  v-if="item.DealStatus === 6"
                  v-permission="'dci_maintain_finish-PUT'"
                >
                  <i class="far fa-save"></i> 更改办结信息
                </el-button>
              </div>

              <div class="border-style">处理信息</div>

              <table
                border="1"
                bordercolor="#dedede"
                style="
                  width: 100%;
                  border-collapse: collapse;
                  font-size: 13px;
                  margin-bottom: 15px;
                "
              >
                <tr height="40">
                  <th width="15%">处理人</th>
                  <td width="35%">
                    <div v-if="item.DealPeople">
                      {{ item.DealPeople.Name }}
                    </div>
                  </td>
                  <th width="15%">维修人员</th>
                  <td width="35%">
                    <div v-if="item.MaintainUser">
                      {{ item.MaintainUser.Name }}
                    </div>
                  </td>
                </tr>
                <tr height="40">
                  <th>检验项目</th>
                  <td>{{ item.InspectionItems }}</td>
                  <th>不合格等级</th>
                  <td>{{ item.Grade }}</td>
                </tr>
                <tr height="40">
                  <th>原因分析</th>
                  <td colspan="3">{{ item.ReasonAnalyse }}</td>
                </tr>
                <tr height="40">
                  <th>检验结论</th>
                  <td colspan="3">{{ item.InspectionConclusion }}</td>
                </tr>
                <tr height="40">
                  <th>维修方案</th>
                  <td colspan="3">{{ item.MaintainScheme }}</td>
                </tr>
                <tr height="40">
                  <th>更换方式</th>
                  <td>
                    <div v-if="item.ReplacementMode === 0">不更换</div>
                    <div v-else-if="item.ReplacementMode === 1">更换配件</div>
                    <div v-else-if="item.ReplacementMode === 2">更换整机</div>
                  </td>
                  <th>补充说明</th>
                  <td>{{ item.SupplementaryDesc }}</td>
                </tr>
                <tr height="40">
                  <th>初检完成日期</th>
                  <td>
                    <div v-if="item.InspectAt">
                      {{ $sys.dateFormat(item.InspectAt, "Y-m-d H:i:s") }}
                    </div>
                  </td>
                  <th>维修完成日期</th>
                  <td>
                    <div v-if="item.DealAt">
                      {{ $sys.dateFormat(item.DealAt, "Y-m-d H:i:s") }}
                    </div>
                  </td>
                </tr>
              </table>

              <div class="border-style" v-if="item.ReplacementMode !== 0">
                更换申请信息
              </div>

              <table
                border="1"
                bordercolor="#dedede"
                style="
                  width: 100%;
                  border-collapse: collapse;
                  font-size: 13px;
                  margin-bottom: 15px;
                "
                v-if="item.ReplacementMode !== 0"
              >
                <tr height="40">
                  <th width="15%">
                    <div v-if="item.Type === 0">产品型号名称</div>
                    <div v-else>配件型号名称</div>
                  </th>
                  <td width="35%">
                    <div v-if="item.DciProductMaintainReplacement">
                      <div v-if="item.Type === 0">
                        <div v-if="item.DciProduct">
                          <div v-if="item.DciProduct.DciProductModel">
                            {{ item.DciProduct.DciProductModel.NameNumber }}
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <div v-if="item.DciAccessory">
                          <div v-if="item.DciAccessory.DciAccessoryModel">
                            {{ item.DciAccessory.DciAccessoryModel.NameNumber }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                  <th width="15%">
                    <div v-if="item.Type === 0">产品SN</div>
                    <div v-else>配件SN</div>
                  </th>
                  <td width="35%">
                    <div v-if="item.DciProductMaintainReplacement">
                      <div v-if="item.Type === 0">
                        <div v-if="item.DciProduct">
                          {{ item.DciProduct.SN }}
                        </div>
                      </div>
                      <div v-else>
                        <div v-if="item.DciAccessory">
                          {{ item.DciAccessory.SN }}
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr height="40">
                  <th>企业名称</th>
                  <td>
                    <div v-if="item.DciProductMaintainReplacement">
                      {{ item.DciProductMaintainReplacement.EntName }}
                    </div>
                  </td>
                  <th>站点名称</th>
                  <td>
                    <div v-if="item.DciProductMaintainReplacement">
                      {{ item.DciProductMaintainReplacement.StationName }}
                    </div>
                  </td>
                </tr>
                <tr height="40">
                  <th>是否质保</th>
                  <td>
                    <div v-if="item.DciProductMaintainReplacement">
                      <div
                        v-if="
                          item.DciProductMaintainReplacement.IsWarrantyPeriod
                        "
                      >
                        是
                      </div>
                      <div v-else>否</div>
                    </div>
                  </td>
                  <th>是否我司运维期</th>
                  <td>
                    <div v-if="item.DciProductMaintainReplacement">
                      <div
                        v-if="
                          item.DciProductMaintainReplacement.IsMaintenancePeriod
                        "
                      >
                        是
                      </div>
                      <div v-else>否</div>
                    </div>
                  </td>
                </tr>
                <tr height="40">
                  <th>故障说明</th>
                  <td colspan="3">
                    <div v-if="item.DciProductMaintainReplacement">
                      {{ item.DciProductMaintainReplacement.MalfunctionDesc }}
                    </div>
                  </td>
                </tr>
                <tr height="40">
                  <th>维修方案</th>
                  <td colspan="3">
                    <div v-if="item.DciProductMaintainReplacement">
                      {{ item.DciProductMaintainReplacement.MaintainScheme }}
                    </div>
                  </td>
                </tr>
              </table>
            </el-form>
          </el-col>
          <el-col :span="8">
            <el-timeline reverse>
              <el-timeline-item
                v-for="(activity, index) in activities"
                :key="index"
                :timestamp="
                  $sys.dateFormat(activity.UpdatedAt) + ' ' + activity.Operator
                "
                placement="top"
              >
                <el-card>
                  <p style="margin-top: 0px; margin-bottom: 0px">
                    {{ activity.Content }}
                  </p>
                </el-card>
              </el-timeline-item>
            </el-timeline>
          </el-col>
        </el-row>

        <div class="border-style" v-if="item.Type === 0">配件列表</div>
        <el-table :data="accList" v-if="item.Type === 0">
          <el-table-column type="index" width="40"></el-table-column>
          <el-table-column
            prop="DciAccessoryModel.NameNumber"
            label="配件型号名称"
          />
          <el-table-column prop="SN" label="当前配件SN" width="220" />
          <el-table-column label="质保开始日期" width="110">
            <template slot-scope="scope">
              <div v-if="scope.row.QualityStartAt">
                {{ $sys.dateFormat(scope.row.QualityStartAt, "Y-m-d") }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="质保结束日期" width="110">
            <template slot-scope="scope">
              <div v-if="scope.row.QualityEndAt">
                {{ $sys.dateFormat(scope.row.QualityEndAt, "Y-m-d") }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="ChangedDciAccessorySN"
            label="原配件SN"
            width="220"
          />
        </el-table>

        <div
          class="border-style"
          v-if="
            item.Type === 1 &&
            item.DciAccessory &&
            item.DciAccessory.OrSN != item.DciAccessory.SN
          "
        >
          更换配件信息
        </div>

        <table
          border="1"
          bordercolor="#dedede"
          style="
            width: 100%;
            border-collapse: collapse;
            font-size: 13px;
            margin-bottom: 15px;
          "
          v-if="
            item.Type === 1 &&
            item.DciAccessory &&
            item.DciAccessory.OrSN != item.DciAccessory.SN
          "
        >
          <tr height="40">
            <th width="15%">
              <div>配件型号名称</div>
            </th>
            <td width="35%">
              <div v-if="item.DciAccessory">
                <div v-if="item.DciAccessory.DciAccessoryModel">
                  {{ item.DciAccessory.DciAccessoryModel.NameNumber }}
                </div>
              </div>
            </td>
            <th width="15%">
              <div>质保开始日期</div>
            </th>
            <td width="35%">
              <div v-if="item.DciAccessory">
                {{ $sys.dateFormat(item.DciAccessory.QualityStartAt, "Y-m-d") }}
              </div>
            </td>
          </tr>
          <tr height="40">
            <th width="15%">
              <div>新配件SN</div>
            </th>
            <td width="35%">
              <div v-if="item.DciAccessory">
                {{ item.DciAccessory.SN }}
              </div>
            </td>
            <th width="15%">
              <div>质保结束日期</div>
            </th>
            <td width="35%">
              <div v-if="item.DciAccessory">
                {{ $sys.dateFormat(item.DciAccessory.QualityEndAt, "Y-m-d") }}
              </div>
            </td>
          </tr>
          <tr height="40">
            <th>原配件SN</th>
            <td colspan="3">
              <div v-if="item.DciAccessory">
                {{ item.DciAccessory.OrSN }}
              </div>
            </td>
          </tr>
        </table>
      </el-tab-pane>

      <el-tab-pane label="产品信息" v-if="item.Type === 0" name="tabProInfo">
        <div class="border-style">产品信息</div>
        <el-form :model="proInfoItem" v-if="proInfoItem.ID" label-width="150px">
          <table
            border="1"
            bordercolor="#dedede"
            style="
              width: 100%;
              border-collapse: collapse;
              font-size: 13px;
              margin-bottom: 15px;
            "
          >
            <tr height="40">
              <th width="15%">产品型号名称</th>
              <td width="35%">
                <div v-if="proInfoItem.DciProductModel">
                  {{ proInfoItem.DciProductModel.Name }}
                </div>
              </td>
              <th width="15%">产品型号</th>
              <td width="35%">
                <div v-if="proInfoItem.DciProductModel">
                  {{ proInfoItem.DciProductModel.Number }}
                </div>
              </td>
            </tr>
            <tr height="40">
              <th>产品SN</th>
              <td>{{ proInfoItem.SNRemark }}</td>
              <th>文件系统版本</th>
              <td>
                <div v-if="proInfoItem.DciPvProductVersion">
                  {{ proInfoItem.DciPvProductVersion.PvName }}
                </div>
              </td>
            </tr>
            <tr height="40">
              <th>质保开始日期</th>
              <td v-if="proInfoItem.QualityStartAt">
                {{ $sys.dateFormat(proInfoItem.QualityStartAt, "Y-m-d") }}
              </td>
              <td v-else></td>
              <th>质保结束日期</th>
              <td v-if="proInfoItem.QualityEndAt">
                {{ $sys.dateFormat(proInfoItem.QualityEndAt, "Y-m-d") }}
              </td>
              <td v-else></td>
            </tr>
            <tr height="40">
              <th>客户</th>
              <td>{{ proInfoItem.ClientName }}</td>
              <th>出库日期</th>
              <td v-if="proInfoItem.StockoutAt">
                {{ $sys.dateFormat(proInfoItem.StockoutAt, "Y-m-d") }}
              </td>
              <td v-else></td>
            </tr>
            <tr height="40">
              <th>出库单号</th>
              <td>{{ proInfoItem.CheckoutNo }}</td>
              <th>出库经办人</th>
              <td>{{ proInfoItem.Operator }}</td>
            </tr>
            <tr height="40">
              <th>合同编号</th>
              <!-- <td>{{ proInfoItem.ContractNo }}</td> -->
              <td>
                <el-tag
                  v-for="contractNo in proInfoItem.ContractNos"
                  :key="contractNo"
                  style="margin-right: 5px; color: #00b3ca"
                  >{{ contractNo }}</el-tag
                >
              </td>
              <th>领用人</th>
              <td>{{ proInfoItem.Recipient }}</td>
            </tr>
            <tr height="40">
              <th>出库备注</th>
              <td colspan="3">{{ proInfoItem.StockoutReason }}</td>
            </tr>
            <tr height="40">
              <th>点位名称</th>
              <td>
                <div v-if="proInfoItem.DciStation">
                  {{ proInfoItem.DciStation.Name }}
                </div>
              </td>
              <th>MN</th>
              <td>
                <div v-if="proInfoItem.DciStation">
                  {{ proInfoItem.DciStation.MN }}
                </div>
              </td>
            </tr>
          </table>
          <div
            style="
              text-align: right;
              padding-top: -10px;
              margin-top: -10px;
              margin-bottom: 10px;
            "
          >
            <el-button
              type="primary"
              size="mini"
              v-if="canEdit"
              @click="onEdit"
            >
              <i class="far fa-save"></i> 修改产品信息
            </el-button>
          </div>
        </el-form>

        <div class="border-style">运维信息</div>
        <el-form :model="contractItem" label-width="150px">
          <table
            border="1"
            bordercolor="#dedede"
            style="width: 100%; border-collapse: collapse; font-size: 13px"
          >
            <tr height="40">
              <th width="15%">运维合同编号</th>
              <td width="35%" v-if="contractItem">
                {{ contractItem.sn }}
              </td>
              <td v-else></td>
              <th width="15%">合同客户企业</th>
              <td width="35%" v-if="contractItem && contractItem.Partner">
                {{ contractItem.Partner.name }}
              </td>
              <td v-else></td>
            </tr>
            <tr height="40">
              <th>运维开始日期</th>
              <td v-if="contractItem && contractItem.begin_at">
                {{ $sys.dateFormat(contractItem.begin_at, "Y-m-d") }}
              </td>
              <td v-else></td>
              <th>运维结束日期</th>
              <td v-if="contractItem && contractItem.end_at">
                {{ $sys.dateFormat(contractItem.end_at, "Y-m-d") }}
              </td>
              <td v-else></td>
            </tr>
            <tr height="40">
              <th>负责小组</th>
              <td v-if="contractItem">
                {{ contractItem.team_name }}
              </td>
              <td v-else></td>
              <th>负责人</th>
              <td v-if="contractItem">
                {{ contractItem.staff_name }}
              </td>
              <td v-else></td>
            </tr>
          </table>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="配件信息" v-if="item.Type === 1" name="tabAccInfo">
        <el-form :model="accInfoItem" v-if="accInfoItem.ID" label-width="150px">
          <table
            border="1"
            bordercolor="#dedede"
            style="width: 100%; border-collapse: collapse; font-size: 13px"
          >
            <tr height="40">
              <th width="15%">配件型号名称</th>
              <td width="35%">
                <div v-if="accInfoItem.DciAccessoryModel">
                  {{ accInfoItem.DciAccessoryModel.Name }}
                </div>
              </td>
              <th width="15%">配件型号</th>
              <td width="35%">
                <div v-if="accInfoItem.DciAccessoryModel">
                  {{ accInfoItem.DciAccessoryModel.Number }}
                </div>
              </td>
            </tr>
            <tr height="40">
              <th>配件SN</th>
              <td>{{ accInfoItem.SN }}</td>
              <th>关联产品SN</th>
              <td>
                <div v-if="accInfoItem.DciProduct">
                  {{ accInfoItem.DciProduct.SN }}
                </div>
                <div v-else>——</div>
              </td>
            </tr>
            <tr height="40">
              <th>客户</th>
              <td>{{ accInfoItem.ClientName }}</td>
              <th>质保开始日期</th>
              <td>
                {{ $sys.dateFormat(accInfoItem.QualityStartAt, "Y-m-d") }}
              </td>
            </tr>
            <tr height="40">
              <th>出库日期</th>
              <td>{{ $sys.dateFormat(accInfoItem.StockoutAt, "Y-m-d") }}</td>
              <th>质保结束日期</th>
              <td>{{ $sys.dateFormat(accInfoItem.QualityEndAt, "Y-m-d") }}</td>
            </tr>
            <tr height="40">
              <th>出库单号</th>
              <td>{{ accInfoItem.CheckoutNo }}</td>
              <th>出库经办人</th>
              <td>{{ accInfoItem.Operator }}</td>
            </tr>
            <tr height="40">
              <th>领用人</th>
              <td>{{ accInfoItem.Recipient }}</td>
              <th>出库备注</th>
              <td colspan="3">{{ accInfoItem.StockoutReason }}</td>
            </tr>
          </table>
        </el-form>
      </el-tab-pane>
    </el-tabs>

    <edit v-model="editItem" :visible.sync="editVisible" @form:saved="flush" />

    <finish-form
      v-model="finishItem"
      :visible.sync="finishVisible"
      @form:saved="initData"
    />
  </el-dialog>
</template>

<script>
import Edit from "./edit.vue";
import FinishForm from "../maintainFinish/finishForm.vue"; //维修办结
export default {
  components: {
    Edit,
    FinishForm,
  },
  props: {
    value: Object,
    visible: Boolean,
    canEdit: Boolean, //是否可以修改产品出库信息，维修处理步骤才可编辑
  },
  data() {
    return {
      ID: "",
      item: _.clone(this.value),
      activeTab: "tabRegister",
      proInfoItem: {}, //产品信息
      accInfoItem: {}, //配件信息
      accList: [], //配件列表
      activities: [], //日志

      //运维合同信息
      contractItem: {
        id: "",
        sn: "", //合同编号
        begin_at: "",
        end_at: "",
        team_name: "", //负责小组
        staff_name: "", //负责人
        partner_id: "",
        Partner: {
          id: "",
          name: "", //合同客户企业
        },
      },

      finishItem: this.getEmptyFinishItem(),
      finishVisible: false, //维修办结
      editItem: {},
      editVisible: false, //编辑产品信息
    };
  },

  methods: {
    onOpen() {
      this.item = _.cloneDeep(this.value);
      this.ID = this.item.ID;
      this.item = {};
      this.initData();
      this.activeTab = "tabRegister";
    },
    initData() {
      this.item = {};
      this.proInfoItem = {};
      this.accInfoItem = {};
      this.activities = [];
      this.accList = [];
      this.contractItem = {};

      this.$axios
        .get(`dci/maintain/${this.ID}`)
        .then((response) => {
          this.item = response.data;
          if (this.item.Type === 0) {
            this.proInfoItem = this.item.DciProduct;
            this.accList = this.item.DciProduct.DciAccessories;
          } else {
            this.accInfoItem = this.item.DciAccessory;
          }
          this.activities = this.item.DciProductMaintainLogs;

          if (
            this.item.DciProduct &&
            this.item.DciProduct.DciStation &&
            this.item.DciProduct.DciStation.MN != ""
          ) {
            this.$axios
              .get("dci/station/getContractInfo", {
                params: { mn: this.item.DciProduct.DciStation.MN },
              })
              .then((response) => {
                this.contractItem = response.data;
              })
              .catch(({ response }) => {
                // this.$sys.alarmResponse(response);
              });
          }
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
    onClose() {
      this.$emit("update:visible", false);
      this.$emit("cancel");
    },

    //点击修改出库信息
    onEdit() {
      this.editItem = this.proInfoItem;
      this.editVisible = true;
    },
    flush() {
      this.$axios
        .get(`dci/product/${this.proInfoItem.ID}`)
        .then((response) => {
          this.proInfoItem = response.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
    //修改维修办结信息
    onUpdateFinishClick(row) {
      this.finishItem = this.getEmptyFinishItem();
      this.finishItem = this.item;
      this.finishVisible = true;
    },
    getEmptyFinishItem() {
      return {
        ID: "", //维修id
        FinishDesc: "", //办结说明
        ExpressNumber: "", //快递单号
        SendingAt: new Date(), //寄出日期
        Addressee: "", //收件人
        ExpressDesc: "", //快递说明
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.el-timeline {
  margin: 0;
  font-size: 10px;
  list-style: none;
}
.el-card__body {
  padding: 5px;
}
.el-timeline-item__timestamp {
  color: #909399;
  line-height: 1;
  font-size: 8px;
}

.ds-detail {
  .el-tabs__header {
    z-index: 0;
  }
  .fix-width {
    width: 120px;
  }
  table th td,
  table tr td {
    padding: 2px 5px;
    height: 30px;
    line-height: 30px;
    table-layout: FIXED;
    word-break: break-all;
  }
  table th {
    text-align: center;
    // padding-left: 5px;
    color: #646566;
    background-color: #ecf5ff;
    font-size: 11px;
  }
  .border-style {
    height: 28px;
    line-height: 28px;
    border-radius: 0 15px 15px 0;
    border-left: 3px solid #409eff;
    padding-left: 5px;
    margin-bottom: 10px;
    background-color: #ecf5ff;
    color: #409eff;
    font-size: 13px;
    font-weight: bolder;
  }
}
</style>
